export const REMINDER_MS = 60000;

// One sound per minute per account/browser, even if several tabs are armed.
export function createReminderController({ now = Date.now, storage, withLock, play, onPlayed = () => {} }) {
  let disposed = false;
  let version = 0;
  let lastLocal = null;
  let busy = false;
  return {
    invalidate() { version += 1; },
    dispose() { disposed = true; version += 1; },
    async tick({ scope, enabled, armed, items }) {
      if (disposed || busy || !enabled || !armed || !items.length) return false;
      const generation = version;
      busy = true;
      try {
        return await withLock(`ca-service-reminder:${scope}`, async () => {
          if (disposed || generation !== version) return false;
          const at = now();
          const key = `ca-service-reminder:last:${scope}`;
          let shared;
          try { const raw = storage.getItem(key); shared = raw === null ? null : Number(raw); } catch { shared = null; }
          const previous = Math.max(lastLocal ?? -Infinity,
            shared !== null && Number.isFinite(shared) && shared >= 0 && shared <= at ? shared : -Infinity);
          if (at - previous < REMINDER_MS) return false;
          if (!(await play()) || disposed || generation !== version) return false;
          lastLocal = at;
          try { storage.setItem(key, String(at)); } catch { /* Current tab still observes its own minute. */ }
          onPlayed(at);
          return true;
        });
      } finally { busy = false; }
    },
  };
}
